/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import styled from 'styled-components';
import { Checkbox, TextArea, palette } from 'component-library';

import { InputsContainer, InputsRow, SelectInput } from './Form/styled';

import NumberInput from './Form/NumberInput';

const TextAreaContainer = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  color: ${palette.Grey700};
  font-size: 0.875rem;
  font-weight: 500;
`;

const LaborTicketForm = ({ form, handleFormChange }) => {
  return (
    <div>
      <InputsContainer>
        <InputsRow>
          <NumberInput
            label="Total Parts"
            path="totalParts"
            form={form}
            handleFormChange={handleFormChange}
          />
          <NumberInput
            label="Rejected Parts"
            path="rejectedParts"
            form={form}
            handleFormChange={handleFormChange}
          />
        </InputsRow>

        {!!form.rejectedParts.value && (
          <SelectInput
            label="ERP Reject Reason"
            onChange={(option) => {
              handleFormChange('rejectReason', option.value);
            }}
            options={[
              { label: 'Option 1', value: '1' },
              { label: 'Option 2', value: '2' },
              { label: 'Option 3', value: '3' },
            ]}
            placeholder="Please select one"
            labelStyles={{
              fontSize: '0.875rem',
              fontWeight: 500,
            }}
            required
          />
        )}

        <TextAreaContainer>
          <label htmlFor="comment">Additional Comments</label>
          <TextArea
            id="comment"
            name="comment"
            rows="8"
            expand
            placeholder="Let us know anything that might be helpful"
          />
        </TextAreaContainer>

        <Checkbox
          inputProps={{
            id: 'workOrderComplete',
            name: 'workOrderComplete',
            checked: form.workOrderComplete.value,
            onChange: () => {
              return handleFormChange(
                'workOrderComplete',
                !form.workOrderComplete.value
              );
            },
          }}
          labelProps={{
            style: {
              fontSize: '0.875rem',
            },
          }}
        >
          Work order complete
        </Checkbox>
      </InputsContainer>
    </div>
  );
};

export default LaborTicketForm;
